import { z } from 'zod'
import { createJSONStorage, persist } from 'zustand/middleware'
import { createStore } from 'zustand/vanilla'

export function createListQueryStore<T extends object>(name: string, schema: z.ZodType<T>) {
  const persistedSchema = z.object({ searches: z.record(z.string(), schema).catch({}) })
  return createStore<{
    searches: Partial<Record<string, T>>
    remember: (accountId: number, search: T) => void
  }>()(
    persist(
      (set) => ({
        searches: {},
        remember: (accountId, search) =>
          set((state) => ({
            searches: { ...state.searches, [accountId]: schema.parse(search) }
          }))
      }),
      {
        name,
        version: 1,
        storage: createJSONStorage(() => localStorage),
        partialize: ({ searches }) => ({ searches }),
        merge: (persisted, current) => {
          const result = persistedSchema.safeParse(persisted)
          return { ...current, searches: result.success ? result.data.searches : {} }
        }
      }
    )
  )
}
